
import { call, put, select, takeEvery } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import getStockStatusComboService from '../../services/stockStatus/getStockStatusComboService'
import commonActions from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchCombosSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'

export function * fetchStockStatusCombo () {
  try {
    yield put(commonActions.showLoader())
    const auth = yield select(getAuth)
    let combo = yield call(getStockStatusComboService, auth.token)
    yield put(fetchCombosSuccess({ stockStatusCombo: combo }))
  } catch (error) {
    const sessionHandler = function * () {
      // yield put(reset('conditionsMaintenanceForm'))
    }
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler, sessionHandler })
  } finally {
    yield put(commonActions.hideLoader())
  }
}

export function * watchFetchStockStatusCombo () {
  yield takeEvery(combosActionTypes.FETCH_STOCK_STATUS_COMBO, fetchStockStatusCombo)
}
